import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from 'semantic-ui-react';
import { translate } from 'react-switch-lang';
import { Title, SaveButton, ClearButton } from '../../../../_fragments';
import { default as Header } from './components/borrow.header';
import { default as Additem } from './components/borrow.additem';
import { default as Footer } from '../../_InventoryFlagments/_InventoryFooter';
import { MyAlert as Alert } from '../../../../_fragments/alert';
import { Grid, Button, Slide } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import BeenhereIcon from '@material-ui/icons/Beenhere';
//****Redux & alert**** */
import { commonAlert } from '../../../../labelConstant';
import { useSelector, useDispatch } from 'react-redux';
import { useAlert } from 'react-alert';
import {
  Save,
  Update,
  ResetItem,
  Clear,
} from './components/redux/actions/borrow.additem.action';

//*** Services *****/
import { BorrowService as service } from '../../../../_services/transaction/asset.borrow.service';
import { clearItem } from '../../_InventoryFlagments/redux/actions/assetsearch.action';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  bg: {
    background: 'linear-gradient(45deg, #b2dfdb 30%, #1976d2 90%)',
    padding: theme.spacing(3, 3, 0),

    // background: '#bbdefb',
  },
  bgBodyCard: {
    background: '#cfd8dc',
  },
  button: {
    margin: theme.spacing(1),
  },
  btnSave: {
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(1),
  },
  btnArroved: {
    color: theme.palette.secondary.main,
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(1),
  },
  btnBack: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(1),
  },
}));

const AssetBorrowForm = (props) => {
  const { t, history } = props;
  const classes = useStyles();
  //states
  let isReadOnly = false;
  let isCreate = false;
  if (!!props.location.state) {
    isReadOnly = props.location.state.isReadOnly;
    if (props.location.state.status == 'APPROVE') {
      isReadOnly = true;
    }
    if (props.location.state.action == 'create') {
      isCreate = true;
    }
  } else {
    isReadOnly = false;
  }

  const [submitting, setSubmitting] = useState(false);
  const [submitstatus, setsubmitstatus] = useState(false);
  const dispatch = useDispatch();
  const alert = useAlert();
  const storage = useSelector((state) => state.borrowStore);
  const {
    handleSubmit,
    errors,
    reset,
    control,
    register,
    setValue,
    getValues,
  } = useForm();

  let myData = {
    code: '',
    dateValue: null,
    ownerType: null,
    borrowBy: null,
    remark: '',
    Reason: null,
    borrowDate: null,
    returnDate: null,
    borrowDetail: [],
  };

  // useEffect(() => {
  //   dispatch(clearItem());
  // }, []);

  const [direction, setDirection] = useState({
    slide: 'left',
    in: true,
    timeout: 650,
  });

  const onsubmitAsync = async (data) => {
    setSubmitting(true);
    try {
      const storageSelector = (Obj) => {
        return Object.keys(Obj).map((storageKey) => Obj[storageKey]);
      };

      const storageArray = storageSelector(storage);
      //console.log('storageArray:>', storageArray);
      if (storageArray.length == 0) {
        window.alert('Please add item before save');
        return;
      }
      myData = {
        ...myData,
        code: data.code,
        dateValue: data.dateValue,
        ownerType: data.OwnerType.value,
        borrowBy: data.borrowby.value,
        remark: data.remark,
        Reason: data.reason.value,
        borrowDate: data.BorrowDate,
        returnDate: data.ReturnDate,
        borrowDetail: storageArray,
      };
      //console.log('theData:', myData);

      Alert.Confirm('Do you confirm to save ?').then((res) => {
        if (res.value) {
          confirmEvent();
        }
      });

      const confirmEvent = async () => {
        if (true) {
          try {
            if (props.location.state.action == 'create') {
              console.log('created...');
              // console.log('created data: ', myData);
              dispatch(Save(myData));
              dispatch(clearItem);
              setSubmitting(false);
            }
            if (props.location.state.action == 'edit') {
              console.log('edit...');
              dispatch(Update(myData));
              dispatch(clearItem);
              setSubmitting(false);
            }

            if (props.location.state.action == 'view') {
              console.log('view...');
              dispatch(clearItem);
              setSubmitting(false);
            }
          } catch (error) {
            console.log('error-confirmEvent', error);
            setSubmitting(false);
          }
        } else {
          setSubmitting(false);
        }
      };

      // dispatch(Save(theData));
      // dispatch(ResetItem);
      // setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      window.alert('ERROR: Insert Not Successfull!');
    }
  };

  const approveEvent = async () => {
    const result = await service.Approve(props.match.params.id);
    if (result === 'OK') {
      alert.show('Approved', {
        timeout: 2000,
        type: 'success',
      });
      history.goBack();
    } else {
      alert.error('ERROR');
    }
  };

  return (
    <>
      <Slide
        timeout={direction.timeout}
        direction={direction.slide}
        in={direction.in}
        mountOnEnter
        unmountOnExit
      >
        <form
          key="formAssetBorrowInsert"
          onSubmit={handleSubmit(onsubmitAsync)}
          size="small"
          noValidate
          //loading={submitting}
          //success={props.success}
        >
          <Grid container>
            <Grid item xs={12} sm={7}>
              <Title
                icon="cubes"
                iconaction="exchange"
                content="Asset Borrow"
                description={
                  !!props.location.state.action
                    ? props.location.state.action
                    : ''
                }
                props={props}
              />
            </Grid>
            <Grid item style={{ textAlign: 'end' }} xs={12} sm={5}>
              {!isReadOnly && (
                <>
                  {!isCreate && (
                    <Button
                      name="approveBtn"
                      className={classes.btnArroved}
                      size="large"
                      color="secondary"
                      variant="outlined"
                      startIcon={<BeenhereIcon />}
                      onClick={(e) => {
                        e.preventDefault();
                        approveEvent();
                      }}
                    >
                      Approve
                    </Button>
                  )}

                  <Button
                    className={classes.btnSave}
                    variant="outlined"
                    type="submit"
                    size="large"
                    startIcon={<SaveIcon />}
                    name="submitBtn"
                  >
                    Save
                  </Button>
                </>
              )}

              <Button
                className={classes.btnBack}
                name="backBtn"
                size="large"
                color="default"
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  setDirection({
                    ...direction,
                    slide: 'left',
                    in: false,
                  });
                  setTimeout(() => {
                    history.goBack();
                    dispatch(clearItem());
                  }, direction.timeout);
                }}
              >
                Back
              </Button>
            </Grid>
          </Grid>
          <Divider />
          <Header
            code={props.match.params.id}
            register={register}
            getValues={getValues}
            setValue={setValue}
            errors={errors}
            control={control}
            reset={reset}
            readOnly={isReadOnly}
          />
          <Additem
            code={props.match.params.id}
            register={register}
            getValues={getValues}
            setValue={setValue}
            errors={errors}
            control={control}
            reset={reset}
            readOnly={isReadOnly}
          />
        </form>
      </Slide>
    </>
  );
};

export default translate(AssetBorrowForm);
